/**
 * Operate Manage - English (US)
 * 运营管理 - 美式英语
 */
export default {
  title: 'Operate Manage',
  supervisorManage: 'Supervisor Manage',
  supervisorCheck: 'Supervisor Check',
  supervisorData: 'Supervisor Data',
  supervisorEvaluationScore: 'Supervisor Evaluation Score',
   // 督学管理页
  supervisorRoom: 'Squirrel AI Supervisor Room',
  dataUpdateTime: 'Data updated at',
  studentData: 'Student Data',
  monthActive: 'Monthly Active',
  vsLastMonth: 'vs last month',
  supervisorCount: 'Supervisors',
  activeCount: 'Active',
  people: ' people',
  serviceRetention: 'Service Retention',
  serviceCenterAllStudents: 'All students in service center',
  serviceRetentionTip: '3-month retention: of students supervised 3 months ago, the share still supervised this month with ≥4h study time. 6/9/12-month retention defined similarly.',
  accountManage: 'Account Manage',
  quickIdentity: 'Quick Identity',
  assignPermission: 'Assign Permission',
  employeeAccount: 'Employee Account',
  addEmployee: 'Add Employee',
  schoolDataBase: 'School Database',
  autoOrderConfig: 'Auto Order Config',
  supervisorEvaluation: 'Supervisor Evaluation',
  // 督学师考评
  abilityEval: 'Ability Evaluation',
  toEval: 'To Evaluate',
  evaluated: 'Evaluated',
  evalCount: 'Eval Count',
  firstTime: 'First',
  secondTime: 'Second',
  listenRecord: 'Listen',
  score: 'Score',
  lastScoreDetail: 'Last Score',
  playRecord: 'Play Recording',
  evalScore: 'Evaluation Score',
  writeComment: 'Comment:',
  optionalComment: '(Optional)',
  scoreDetail: 'Score Detail',
  difficultyExplain: 'Difficulty level:',
  comment: 'Comment:',
  placeholderCampusIdEval: 'Enter campus ID',
  scoreUnit: ' pts',
  // 账户设置 AccountSet 表格与消息
  employeeName: 'Employee: ',
  shortcutConfigPermission: 'Quick Config',
  selectRoleTip: 'Select a sub-account role; the system will auto-configure permissions.',
  configThenAdjust: '(You can adjust manually after.)',
  pagePermissionConfig: 'Page Permission',
  pagePermissionTip: 'Which pages the employee can see',
  functionPermissionConfig: 'Function Permission',
  functionPermissionTip: 'Which functions the employee can see',
  quickSearchAddPermission: 'Search to add permission',
  dataPermissionConfig: 'Data Permission',
  dataPermissionTip: 'Which data the employee can see',
  pleaseConfigRole: 'Please configure role',
  saveSuccess: 'Saved successfully',
  saveFailed: 'Save failed',
  // 账户设置 AccountSet 表格与消息
  createTimeCol: 'Create Time',
  nameCol: 'Name',
  usernameCol: 'Username',
  phoneCol: 'Phone',
  agentNo: 'Agent No.',
  disNo: 'Outbound No.',
  accountStatus: 'Account Status',
  remarkCol: 'Remark',
  employeeRole: 'Employee Role',
  customRole: 'Custom Role',
  unbound: 'Not bound',
  verifySuccess: 'Verified successfully.',
  bindMobileSuccess: 'Phone bound successfully.',
  editAccountFailed: 'Failed to update account.',
  // 安全验证/绑定手机号弹窗
  securityVerify: 'Security Verification',
  securityTip: 'Enter your password to continue.',
  loginPassword: 'Password: ',
  placeholderLoginPassword: 'Enter password',
  bindMobile: 'Bind Phone',
  enterLoginPassword: 'Enter password',
  placeholderBindMobile: 'Enter phone number',
  getCode: 'Get Code',
  resendAfter: 'Resend in {n}s',
  codeCol: 'Code: ',
  placeholderCode: 'Enter verification code',
  enterBindMobile: 'Enter phone number',
  invalidPhone: 'Invalid phone format',
  enterCode: 'Enter verification code',
  // 员工账号 EmployeesAccount
  resignRecord: 'Resign Record',
  view: 'View',
  edit: 'Edit',
  disable: 'Disable',
  enable: 'Enable',
  wake: 'Wake',
  resign: 'Resign',
  more: 'More',
  reInvite: 'Re-invite',
  cancelInvite: 'Cancel Invite',
  reActivate: 'Re-activate',
  resetPassword: 'Reset Password',
  editRecord: 'Edit Record',
  confirmResetPwdTitle: 'Reset password for',
  confirmResetPwdDesc: '\'s account?',
  resetPwdInitial: 'Password will be reset to initial [songguo123].',
  accountEditRecord: 'Account Edit Record',
  disableConfirmContent: 'After disabling, {username} ({phone}) will not be able to access {systemName}. Continue?',
  resignConfirmContent: 'After resign, {name}\'s ({phone}) data will be cleared and removed from DingTalk. This cannot be undone. Continue?',
  wakeConfirmContent: 'After wake, {username} ({phone}) can access {systemName} and join campus {campusId}. Continue?',
  potentialCustomer: 'Potential Customer',
  supervisorStudent: 'Supervisor Student',
  accountStatusCol: 'Account Status',
  accountRoleCol: 'Account Role',
  updateTimeCol: 'Update Time',
  enableSuccess: 'Enabled',
  enableFailed: 'Enable failed',
  wakeSuccess: 'Woke successfully',
  wakeFailed: 'Wake failed',
  resignSuccess: 'Resigned',
  resignFailed: 'Resign failed',
  editAccountSuccess: 'Account updated',
  addAccountSuccess: 'Account added',
  addAccountFailed: 'Add failed',
  resetPwdSuccess: 'Password reset to songguo123',
  reInviteSuccess: 'Re-invited. Ask employee to check DingTalk.',
  copySuccess: 'Copied',
  handover: 'Handover',
  release: 'Release',
  accountSearchLabel: 'Account:',
  namePlaceholder: 'Name',
  searchNameLabel: 'Name:',
  accountStatusLabel: 'Status:',
  statusAll: 'All',
  statusNormal: 'Active',
  statusDisabled: 'Disabled',
  statusPendingConfirm: 'Pending',
  statusInfoMissing: 'Info Missing',
  statusFrozen: 'Frozen',
  agentNoPlaceholder: 'Seat No.',
  disNoLabel: 'Display No.:',
  disNoPlaceholder: 'Display phone',
  leaveDateLabel: 'Leave Date',
  leaveTimeCol: 'Leave Time',
  opUserCol: 'Operator',
  handoverRecordTitle: 'Handover Record',
  handoverUserCol: 'Handover By',
  assetCol: 'Asset',
  detailCol: 'Detail',
  dateRangeTo: ' to ',
  editRole: 'Edit role',
  deleteRole: 'Delete role',
  confirmDeleteCustomRole: 'Confirm to delete this custom role?',
  deleteSuccess: 'Deleted successfully',
  deleteFailed: 'Delete failed',
  editAccount: 'Edit account',
  addAccount: 'Add account',
  nameLabel: 'Name',
  realNameLabel: 'Real name:',
  previewPermission: 'Preview permission',
  fillBasicInfo: 'Please fill in basic info',
  employeePhoneModifyTip: 'Note: To change employee phone, have the employee log in and go to Account Security after account is created.',
  selectRolePermission: 'Select role permission',
  placeholderRealName: 'Enter real name',
  phoneLabel: 'Phone:',
  placeholderPhoneForRecovery: 'Enter phone for password recovery',
  ruleEnterName: 'Please enter name',
  ruleEnterPhoneForRecovery: 'Please enter phone for password recovery',
  ruleInvalidPhone: 'Please enter valid phone number',
  editFailed: 'Edit failed',
  deleteCustomRoleTip: 'Deleting will not affect employees who previously used this custom role for permission configuration.',
  // 督学数据 SupervisorData tabs
  evaluationScoreTab: 'Evaluation Score',
  supervisorProcess: 'Supervisor Process',
  supervisorResult: 'Supervisor Result',
  newStudentManage: 'New Students',
  supervisorGrowthTab: 'Supervisor Growth',
  supervisorScoreViewStatus: 'Supervisor Score View Status',
  newStudentAndGrowthStatus: 'New Student & Growth Status',
  qualificationRate: 'Qualification Rate',
  // 督学管理 SupervisorManage
  provinceAvg: 'Province Avg',
  scoreRate: 'Score Rate',
  viewAll: 'View All >',
  validScoreCollectRate: 'Valid Score Collect Rate',
  examScoreRate: 'Exam Score Rate',
  newSupervisorNumTitle: 'New Supervisor Students',
  newSupervisorNumTxt: 'Students newly marked as study room or online-only this month',
  noSupervisorNumTitle: 'No Supervisor Students',
  noSupervisorNumTxt: 'Not supervised: no status or status is expired / no supervision',
  noSupervisorActiveNumTitle: 'No-Supervisor Active Students',
  month3: '3 months',
  month6: '6 months',
  month9: '9 months',
  month12: '12 months',

  // 督学代理商数据 SupervisorAgentData
  supervisorAgentDealerLabel: 'Dealer to view:',
  placeholderSupervisorAgentDealerId: 'Enter dealer ID',
  supervisorAgentDealerIdCol: 'Dealer ID',
  supervisorAgentDealerNameCol: 'Dealer name',
  cityNameCol: 'City',
  areaNameCol: 'Area',
  supervisorOverviewCol: 'Supervisor overview',
  supervisorDataCol: 'Supervisor data',

  //  SupervisorCheck 督学检查
  evalDealerLabel: 'Dealer',
  evalDealerIdCol: 'Dealer ID',
  belongCityCol: 'City',
  evalDealerNameCol: 'Dealer name',
  supervisorNameCol: 'Supervisor name',
  contentCol: 'Content',
  uploadRecordTimeCol: 'Upload record time',
  selfScoreCol: 'Self score',
  managerScoreCol: 'Score',
  evaluatorCol: 'Evaluator',
  evalTimeCol: 'Eval time',
  assessTimeCol: 'Assess time',

  // SupervisorManage
  statsPeriodLabel: 'Stats period',
  placeholderSelectMonth: 'Select month',
  midtermExam: 'Midterm',
  finalExam: 'Final',
  yearLabel: 'Year',
  subjectLabel: 'Subject',
  placeholderSelect: 'Select',
  yearSuffix: '',
  // Indicator descriptions
  scoreCollectRateTitle: 'Score Collection Rate',
  scoreCollectRateText: 'Share of supervised students (study room or online-only) with collected exam scores',
  validScoreRateTitle: 'Valid Score Rate',
  validScoreRateText: 'Share of supervised students with valid score proof in current exam',
  examScoreRateTitle: 'Exam Score Improvement Rate',
  examScoreRateText: 'Numerator: Students whose score improved vs last exam. Denominator: Students with two consecutive valid exam scores',
  scoreManageTitle: 'Score manage',
  listGuidelineTitleColon: ': ',
  dataUpdateTimeScoreManage: 'Data updated: ',
  emptyScoreManage: 'No data',
  collectResultNumLabel: 'Collected scores: ',
  effectiveResultNumLabel: 'Valid scores: ',
  supervisorStudentColon: 'Supervised students: ',
  upResultNumLabel: 'Improved students: ',
  twiceResultSupervisorColon: 'Supervised students with two submissions: ',
  supervisorStatusLabel: 'Supervision status: ',
  studyRoomCountLabel: 'Study room ({n})',
  onlineOnlyCountLabel: 'Online-only ({n})',
  scoreTimeRangeMidtermAutumn: 'Oct–Nov',
  scoreTimeRangeMidtermSpring: 'Apr–May',
  scoreTimeRangeFinalAutumn: 'Jan–Feb',
  scoreTimeRangeFinalSpring: 'Jun–Jul',
  scorePeriodLabel: '{year} {range}',
  scorePeriodYearUnit: '',

  // StudentDetails
  studentDetailSubjectLabel: 'Subject',
  placeholderSelectSubject: 'Select subject',
  dateCol: 'Date',
  learnTimeCol: 'Study time',
  subjectNameCol: 'Subject',
  questionMarkRateCol: 'Question mark rate',
  draftMarkRateCol: 'Draft mark rate',
  draftPassRateCol: 'Draft pass rate',
  questionTryCol: 'Question try rate',
  errorAnalyzeCol: 'Error analyze rate',
  fillByCol: 'Filled by',
  viewSummary: 'View summary',

  // SupervisorData columns
  studentNameCol: 'Student name',
  writeRateCol: 'Summary write rate',
  summaryWriteRateCol: 'Write rate',
  teacherNameCol: 'Supervisor name',
  questionTryRateCol: 'Question try rate',
  errorAnalyzeRateCol: 'Error analyze rate',
  questionMarkValidRateCol: 'Read-and-mark validity rate',
  readQuestionMarkRateCol: 'Read question mark rate',
  threeMonthSurvivalRateCol: '3-month retention',
  sixMonthSurvivalRateCol: '6-month retention',
  nineMonthSurvivalRateCol: '9-month retention',
  twelveMonthSurvivalRateCol: '12-month retention',
  thisMonthHighActiveRateCol: 'This month active rate',
  lastMonthHighActiveRateCol: 'Last month active rate',
  beforeLastMonthHighActiveRateCol: 'Before last month active rate',
  supervisorLabel: 'Supervisor',
  superviseStudentCount: 'Supervised Student Count',
  placeholderSelectSupervisor: 'Select supervisor',
  monthLabel: 'Month',
  monthNumberLabel: 'M{n}',
  totalErrorNumCol: 'Total errors',
  levelThreeCol: 'Level 3',
  levelTwoCol: 'Level 2',
  levelOneCol: 'Level 1',
  viewStudentsCol: 'View students',
  writeNumCol: 'Summary write count',
  summaryCoverRateWeek1Col: 'Summary cover rate week 1',
  summaryCoverRateWeek2Col: 'Summary cover rate week 2',
  summaryCoverRateWeek3Col: 'Summary cover rate week 3',
  summaryCoverRateWeek4Col: 'Summary cover rate week 4',
  summaryCoverRateWeek5Col: 'Summary cover rate week 5',
  summaryCoverTip: 'Summary cover rate: students with ≥50min weekly single-subject study who filled summary.',
  newPeopleStudentNameCol: 'New student name',
  newStudentNameOrPhoneLabel: 'New student name or phone',
  placeholderInput: 'Enter',
  newStudentPeriodCol: 'New student period',
  newPeopleStudentNameCol: 'New student name',
  supervisorInChargeCol: 'Supervisor in charge',
  totalStudyTimeCol: 'Total study time',
  draftConditionCol: 'Draft condition',
  independentProcessCol: 'Independent process',
  firstWeekFeedbackCol: 'First week feedback',
  instinctLevelCol: 'Instinct level',
  healthLevelCol: 'Health level upgrade/downgrade',
  recentThreeScoresCol: 'Recent three scores',
  yearMonthCol: 'Month',
  totalScoreCol: 'Total score',
  studyTimeScoreCol: 'Study time',
  activeScoreCol: 'Highly active',
  studyErrorScoreCol: 'Study process error',
  studyMarkScoreCol: 'Study mark',
  validScoreRateCol: 'Valid score rate',
  threeMonthWeightScoreCol: '3-month retention',
  honorNameCol: 'Full process training',
  mathDdjDurationCol: 'Math foundation duration',
  mathDdjMaxProgressCol: 'Math foundation max progress',
  chineseDdjDurationCol: 'Chinese foundation duration',
  chineseDdjMaxProgressCol: 'Chinese foundation max progress',
  englishDdjDurationCol: 'English foundation duration',
  englishDdjMaxProgressCol: 'English foundation max progress',
  difficultyLevelCol: 'Difficulty level ability',
  healthLevelAbilityCol: 'Health level ability',
  supervisorStudentsTitle: "Supervisor's students",
  supervisorSummaryLabel: 'Supervisor summary',
  notFilled: 'Not filled',
  notVisitSupervisor: 'Not in-store supervision',
  getDataFailed: 'Failed to load data',

  // accountEditRecord
  opDesc: 'Operation description',
  opType: 'Operation type',
  opTime: 'Operation time',

  // SupervisorSummary
  back: 'Back',
  supervisorSummary: 'Supervisor summary',
  studyTime: 'Study time',
  effectiveTime: 'Effective time',
  dataUpdateTo: 'Data updated to: ',
  dataUpdateTooltip: 'Daily data updates previous day; weekly data fixed on Monday',
  studyExceptionOverview: 'Study exception overview',
  levelException: ' level exception: ',
  noExceptionThisWeek: 'No exceptions this week!',
  studyMonitorAlarm: 'Study monitor alarm',
  studyExceptionHelp: 'What to do when student study process has exceptions?',
  weekAlarmCount: 'Weekly alarm count: ',
  highestRatio: ' has highest ratio: ',
  dateCol: 'Date',
  studyTimeCol: 'Study time',
  daze: 'Daze',
  times: 'Times',
  durationMin: 'Duration (min)',
  leaveMidway: 'Leave midway',
  consecutiveWrong: 'Consecutive wrong',
  totalWrongCount: 'Total wrong count',
  answerSlowly: 'Answer slowly',
  questionCount: 'Question count',
  wrongCount: 'Wrong count',
  answerFast: 'Answer fast',
  skipVideo: 'Skip video',
  quantity: 'Quantity',
  afterAnswerWrong: 'After answer wrong',

  // SupervisorSummary example trial / draft / read circle / error analysis
  exampleTrialTitle: 'Example trial status',
  exampleTrialNorm: 'Example trial norms',
  weekExampleTrialRate: 'Weekly example trial rate: ',
  videoStillWrongTip: ' videos still wrong after watching, please follow up',
  hasCount: ', ',
  videoStillWrongPrefix: ', ',
  viewTrialErrorKnowledge: 'View trial error knowledge',
  viewDetail: 'View detail',
  draftWritingTitle: 'Draft writing status',
  draftWritingQualifyHelp: 'How to judge draft writing quality?',
  draftSampleRate: 'Draft sample pass rate: ',
  readCircleTitle: 'Read & circle status',
  readCircleHelp: 'How to do read & circle well?',
  completionStatus: 'Completion: ',
  errorAnalysisTitle: 'Error analysis',
  errorAnalysisHelp: 'How to do error analysis?',
  errorAnalysisRequireTip: 'When doing level 1-6 (first two times) foundation, error analysis is required',
  weekErrorAnalysisRate: 'Weekly 1-6 level error analysis rate: ',
  trialErrorRightLabel: 'Wrong then got it after video',
  trialErrorWrongLabel: 'Wrong still not after video',
  draftWritingRateLabel: 'Draft writing rate',
  draftPassRateLabel: 'Draft pass rate',
  draftRightRateLabel: 'Draft question correct rate',
  noDraftRightRateLabel: 'No-draft question correct rate',
  totalRightRateLabel: 'Overall correct rate',
  readCircleCount: 'Read circle count',
  readCircleRate: 'Read circle rate',
  readCircleRightRate: 'Read circle correct rate',
  noReadCircleRightRate: 'No-read circle correct rate',
  invalidReadCircleCount: 'Invalid read circle count',
  validReadCircleRate: 'Valid read circle rate',
  courseLevelNumLabel: 'Course level/batch',
  errorAnalysisStatusLabel: 'Error analysis status',
  errorAnalysisRequireLabel: 'Error analysis required',
  learnErrorCount: 'Learned error count',
  markedErrorCount: 'Marked error count',
  errorMarkRate: 'Error mark rate',
  uploadedImagesLabel: 'Uploaded images',
  levelLabel: ' level',
  batchLabel: 'Batch ',
  batchSuffix: '',
  weekTotal: 'Week total',
  trialErrorKnowledgeDialogTitle: 'Trial error knowledge',
  trialDateLabel: 'Trial date: ',
  tryResultLabel: 'Try result',
  wrongButGotIt: 'Wrong, got it',
  wrongStillNot: 'Wrong, still not',
  learnRightRateLabel: 'Learn correct rate',
  exceptionScenarioDialogTitle: 'Study exception scenarios',
  alarmDialogTitle: 'Study monitor alarm',
  countDescLabel: 'Count description: ',
  totalVideoCount: 'Total videos',
  exampleTrialCount: 'Example trials',
  trialRightLabel: 'Trial correct',
  totalQuestionCount: 'Total questions',
  draftWritingCount: 'Draft writing count',
  courseLabel: 'Course',
  chapterTaskLabel: 'Chapter/Task',
  knowledgeLabel: 'Knowledge',
  errorTypeLabel: 'Error type',
  questionCountLabel: 'Question count',
  ratioLabel: 'Ratio',
  examProblemLabel: 'Exam problem',
  calcErrorLabel: 'Calc error',
  notKnowLabel: 'Not know',
  systemErrorLabel: 'System error',
  otherLabel: 'Other',
  exampleTrialRate: 'Example trial rate',
  exceptionLevelLabel: 'Exception level',
  severityLabel: 'Severity',
  exceptionScenarioLabel: 'Exception scenario',
  triggerConditionLabel: 'Trigger condition',
  alarmSituationLabel: 'Alarm situation',

  // ScoreRuleDialog
  scoreRuleTitle: 'How is the score calculated?',
  scoreRuleIntro: 'Total score (max 10) is determined by 5 dimensions.',
  scoreRuleGotIt: 'Got it',
  scoreRuleDimension: 'Dimension',
  scoreRuleTotalScore: 'Total',
  scoreRuleWeight: 'Weight',
  scoreRuleStudyTime: 'Study time',
  scoreRuleHighActive: 'High activity',
  scoreRuleStudyError: 'Study process exception',
  scoreRuleStudyMark: 'Study trace',
  scoreRule3MonthRetention: '3-month retention',
  scoreRule10Points: '10 pts',
  scoreRuleWeight25: '25%',
  scoreRuleWeight25New: '25% (new) / 25% (returning)',
  scoreRuleWeight0New: '0% (new) / 10% (returning)',
  scoreRuleBasis: 'Basis: ',
  scoreRuleStudyTimeDesc1: 'Based on weekly average study time of supervised students.',
  scoreRuleStudyTimeDesc2: 'Weekly score: T = max study time per subject',
  scoreRuleStudyTimeDesc3: 'Spring/Fall: T ÷ 6 × 10, max 10 pts',
  scoreRuleStudyTimeDesc4: 'Summer/Winter: T ÷ 20 × 10, max 10 pts',
  scoreRuleStudyTimeDesc5: 'Monthly score = average of weekly scores.',
  scoreRuleHighActiveDesc1: 'Based on high-activity ratio of supervised students',
  scoreRuleHighActiveDesc2: 'National average as baseline; +1 pt per 10% above, -1 pt per 10% below',
  scoreRuleHighActiveDesc3: 'Monthly score = average of weekly scores',
  scoreRuleStudyErrorDesc1: 'Based on study process exceptions',
  scoreRuleStudyErrorDesc2: 'Each student has 10 base pts per week; exceptions deduct',
  scoreRuleStudyErrorDesc3: 'Different exception levels, different deductions; standards vary by season',
  scoreRuleStudyErrorDesc4: 'Weekly score = average of student scores',
  scoreRuleStudyErrorDesc5: 'Monthly score = average of weekly scores',
  scoreRuleStudyMarkDesc1: 'Trace rates during supervision.',
  scoreRuleStudyMarkDesc2: 'Different trace rates map to different scores',
  scoreRule3MonthDesc1: '3-month service retention of supervision result.',
  scoreRule3MonthDesc2: 'Score = 3-month retention ÷ 0.6 × 10',
  scoreRule3MonthNote: 'Note: New supervisors (<3 months) are excluded from this dimension',

  // ImproveScores
  supervisorTeacherLabel: 'Supervisor: ',
  placeholderSelectSupervisorTeacher: 'Select supervisor',
  yearLabelWithColon: 'Year: ',
  termLabel: 'Term: ',
  examTypeLabel: 'Exam type: ',
  improveScoresSubjectLabel: 'Subject',
  supervisorTeacherNameCol: 'Supervisor name',
  schoolYearCol: 'Year',
  termCol: 'Term',
  examTypeCol: 'Exam type',
  scoreCollectRateCol: 'Score collection rate',
  validScoreRateCol: 'Valid score rate',
  scoreImproveRateCol: 'Improvement rate',
  studyRoomStudentNumCol: 'Study room students',
  onlineOnlyStudentNumCol: 'Online-only students',
  submitScoreStudentNumCol: 'Students submitted scores',
  validScoreStudentNumCol: 'Students with valid scores',
  improveStudentNumCol: 'Students improved',
  submitTwiceStudentNumCol: 'Students submitted twice',
  noScoreStudentNumCol: 'Students with no scores',
  dataUpdateTimeLabel: 'Data update time: ',
  foldText: 'Fold',
  expandText: 'Expand',
  clearFilterText: 'Clear filters',

  // SupervisorEvaluationScore
  evaluationScoreMonthDealerLabel: 'Dealer',
  monthDataTab: 'Monthly Data',
  weekDataTab: 'Weekly Data',
  placeholderSelectYear: 'Select year',
  weekEndDateCol: 'Week (End Date)',
  highActiveScoreCol: 'High Activity Score',
  threeMonthRetentionScoreCol: '3-Month Retention Score',

  // Stage & Grade
  preschoolStage: 'Preschool',
  primarySchoolStage: 'Primary',
  juniorHighStage: 'Junior High',
  seniorHighStage: 'Senior High',
  otherStage: 'Other',
  smallClass: 'Small Class',
  middleClass: 'Middle Class',
  bigClass: 'Big Class',
  grade1: 'Grade 1',
  grade2: 'Grade 2',
  grade3: 'Grade 3',
  grade4: 'Grade 4',
  grade5: 'Grade 5',
  grade6: 'Grade 6',
  grade7: 'Grade 7',
  grade8: 'Grade 8',
  grade9: 'Grade 9',
  grade10: 'Grade 10',
  grade11: 'Grade 11',
  grade12: 'Grade 12',
  generalGrade: 'General',

  // Term
  firstTerm: 'First Term',
  secondTerm: 'Second Term',
  autumnTerm: 'Autumn',
  springTerm: 'Spring',

  // Subject
  englishSubject: 'English',
  mathSubject: 'Math',
  chineseSubject: 'Chinese',
  physicsSubject: 'Physics',
  chemistrySubject: 'Chemistry',
  biologySubject: 'Biology',
  geographySubject: 'Geography',
  scienceSubject: 'Science',

  // Task Step Status
  unlocked: 'Unlocked',
  inProgress: 'In Progress',
  completed: 'Completed',

  // Agent Store Status
  openingPending: 'Opening Pending',
  opened: 'Opened',
  openingRejected: 'Opening Rejected',
  siteSelectionPending: 'Site Selection Pending',
  siteSelectionRejected: 'Site Selection Rejected',
  pendingOpening: 'Pending Opening',
  openingCanceled: 'Opening Canceled',
  temporaryClosed: 'Temporary Closed',
  permanentlyClosed: 'Permanently Closed',
  preSitePending: 'Pre-site Pending',
  preSiteRejected: 'Pre-site Rejected',
  preSite: 'Pre-site',
  siteSelectionCanceled: 'Site Selection Canceled',
  preSiteWithdrawn: 'Pre-site Withdrawn',
  siteSelectionWithdrawn: 'Site Selection Withdrawn',
  closurePending: 'Closure Pending',
  reopenPending: 'Reopen Pending',
  storeInStorePending: 'Store-in-Store Pending',
  storeInStoreRejected: 'Store-in-Store Rejected',
  storeInStoreCanceled: 'Store-in-Store Canceled',

  // supervisorGrowth
  mathDdjDurationCol: 'Math Foundation, Total Hours',
  mathDdjMaxProgressCol: 'Math Foundation, Max Progress',
  chineseDdjDurationCol: 'Chinese Foundation, Total Hours',
  chineseDdjMaxProgressCol: 'Chinese Foundation, Max Progress',
  englishDdjDurationCol: 'English Foundation, Total Hours',
  englishDdjMaxProgressCol: 'English Foundation, Max Progress',
  difficultyLevelCol: 'Difficulty Level Explanation Ability',
  healthLevelAbilityCol: 'Health Level Explanation Ability',
  hoursUnit: 'hours',
  levelUnit: 'level',
  noRecording: 'No recording',
  scoreLabel: 'Score: ',
  scoreUnit: 'pts',
  pendingProvincialScore: 'Pending provincial score',
  selfEvalLabel: 'Self-eval: ',
  listenRecording: 'Listen',
  playRecording: 'Play Recording',
  supervisorsNoData: 'supervisors have no data',
  supervisorsNoDataWarn: '{names}: {count} supervisor(s) have no data',

  // newPeople
  viewImage: 'View Image',
  notCompleted: 'Not Completed',
  completed: 'Completed',
  questionMarkCol: 'Question Marking',
  knowledgePointCol: 'Knowledge Point Notes',
  audioParseError: 'Audio parsing error, please re-upload',
  allOption: 'All',
}
